import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '公司类型'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }
]
